import { useQuery, QueryResult } from "@apollo/client";

import { getTokenFromLocalStorage } from "helpers/storage";

import { GET_CURRENT_USER_INFO } from "api/User/queries";

import { GetUser } from "api/User/types/GetUser";

export const useGetCurrentUserInfo = (): QueryResult<GetUser> => {
  const token = getTokenFromLocalStorage();
  const { data, ...rest } = useQuery<GetUser>(GET_CURRENT_USER_INFO, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
    skip: !token,
  });

  return {
    data,
    ...rest,
  };
};
